import React, { useEffect, useState } from 'react';
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { MainInput } from '../../../mainComponent/mainInput';
import { Link } from 'react-router-dom';
import { THEME_COLOR } from '../../../config';
import TouristAppointmentsApi from '../../../services/TouristAppointmentsApi';
import AddCircleIcon from '@mui/icons-material/AddCircle';

function EditActivities(props) {
    const { activityId, onSubmit } = props;
    const [activityName, setActivityName] = useState('');
    const [activityDetails, setActivityDetails] = useState([]);
    const [newDetails, setNewDetails] = useState(['']);
    const { editActivities, getSingleActivity } = TouristAppointmentsApi();

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await getSingleActivity(activityId);
                setActivityName(res?.activity_name || '');
                setActivityDetails(res?.activity_details || []);
            } catch (error) {
                console.error("Error fetching activity data:", error);
            }
        }
        getData();
    }, []);

    const handleNameChange = (e) => {
        setActivityName(e.target.value);
    }

    const handleExistingDetailChange = (e, index) => {
        const updatedDetails = [...activityDetails];
        updatedDetails[index] = e.target.value;
        setActivityDetails(updatedDetails);
    }

    const handleNewDetailChange = (e, index) => {
        const updatedNewDetails = [...newDetails];
        updatedNewDetails[index] = e.target.value;
        setNewDetails(updatedNewDetails);
    }

    // Add new input field for detail
    const addInputBox = () => {
        setNewDetails([...newDetails, '']);
    }

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();
        const allDetails = [
            ...activityDetails,
            ...newDetails.filter(detail => detail.trim() !== '')
        ];

        const activityData = {
            activity: activityName,
            details: allDetails
        };
        try {
            await editActivities(activityId, activityData);
            onSubmit(); // call parent on submit
        } catch (error) {
            console.error("Error updating activity:", error);
        }
    }

    return (
        <form encType='multipart/form-data' onSubmit={handleSubmit}>
            <div className="col-lg-12">
                <div>
                    <label className="font_weight">Activity Name</label>
                    <MainInput
                        type="text"
                        name="activity_name"
                        value={activityName}
                        onChange={handleNameChange}
                        placeholder="Activity Name"
                    />
                </div>

                <label className="font_weight">Activity Details</label>

                {activityDetails.map((detail, index) => (
                    <div key={index}>
                        <MainInput
                            type="text"
                            value={detail}
                            onChange={(e) => handleExistingDetailChange(e, index)}
                            placeholder={`Detail ${index + 1}`}
                        />
                    </div>
                ))}

                {newDetails.map((detail, index) => (
                    <div className="row" key={`new-${index}`}>
                        <div className="mb-3 col-lg-11">
                            <MainInput
                                type="text"
                                value={detail}
                                onChange={(e) => handleNewDetailChange(e, index)}
                                placeholder="New Activity Detail"
                            />
                        </div>
                        {index === newDetails.length - 1 && (
                            <div className="col-lg-1">
                                <Link to="#" onClick={addInputBox}>
                                    <AddCircleIcon style={{ fontSize: 25, color: THEME_COLOR, marginLeft: 5, marginTop: 5 }} />
                                </Link>
                            </div>
                        )}
                    </div>
                ))}

                <div className="text-center p-2 add_top_30">
                    <MainButtonInput>Save</MainButtonInput>
                </div>
            </div>
        </form>
    );
}

export { EditActivities };
